/*
 * @Date: 2022-06-09 15:06:25
 * @LastEditors: guantingting
 * @LastEditTime: 2023-06-13 10:02:42
 */
/**
 * 首页
 */
import {request, oldRequest} from '@/assets/js/request.js'
const fixedUrl = 'app20/product-service/product20'
const userUrl = 'app20/user-base-service/user20'
const cmsUrl = 'app20/cms-service/cms20'

// 根据城市查询poi数据
export function getPoiInfo(data) {
  return request({
    method: 'post',
    url: `${fixedUrl}/api/shop/bindPoi`,
    data: data,
  })
}
// 根据poi信息请求门店信息
export function getCityByPoi(data) {
  return request({
    method: 'post',
    url: `${fixedUrl}/api/shop/list`,
    data: data,
  })
}
// 校验门店是否休息
export function checkBusinessTime(data) {
  return request({
    method: 'post',
    url: `${fixedUrl}/api/shop/checkBusinessTime`,
    data: data,
  })
}
// 根据门店Id获取门店详情
export function getShopInfoData(data) {
  return request({
    method: 'post',
    url: `${fixedUrl}/api/shop/shopDetail`,
    data: data,
  })
}
// 轮播图
export function getBannerImages() {
  return request({
      method: 'get',
      url: `${cmsUrl}/api/homePageV2/m/rent/getBanner`,
      data: {},
  })
}
// 第三方接口
export function thirdParty() {
  return oldRequest({
    method: 'get',
    url: 'web/rv-base-facade/v1/thirdParty',
    data: {},
  })
}
// 更新渠道
export function updateChannel(data) {
  return request({
    method: 'post',
    url: `${userUrl}/api/updateLoginUserChannelInfo`,
    data: data,
  })
}

// 优惠券弹出框
export function couponPopupInfo(data) {
  return request({
    method: 'post',
    url: `${fixedUrl}/api/popupV3/userPopupLogs`,
    data: data,
  })
}

//同程登录校验
export function checkMThirdLogin() {
  return request({
    method: 'post',
    url: `${userUrl}/api/user/checkMThirdLogin`,
    data: {},
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js